import React from 'react';
import classNames from 'classnames';

import './DefaultModalBackground.scss';

const DefaultModalBackground = ({hasSideInfo = false}) => {
  return (
    <div styleName={classNames('ccf-modal-background', {
      'ccf-modal-background--bigger': hasSideInfo
    })}>
      <svg xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 367 577" preserveAspectRatio="none">
        <defs>
          <linearGradient id="popup-linear-gradient" x1="183.448" y1="0" x2="183.448" y2="577" gradientUnits="userSpaceOnUse">
            <stop stopColor="#383865" />
            <stop offset="0.713542" stopColor="#2A2D76" />
            <stop offset="1" stopColor="#212486" />
          </linearGradient>
        </defs>
        <path fillRule="evenodd" clipRule="evenodd"
            d="M365.806 0L16 0C7.16344 0 0 7.16344 0 16V561C0 569.837 7.16344 577 16 577H296.16C328.857 550.243 354.52 515.614 364.303 470.988C374.716 423.491 351.93 376.119 328.591 327.597C312.228 293.577 295.593 258.992 289.938 223.403C278.365 150.571 308.229 46.0935 365.806 0Z"
            fill="url(#popup-linear-gradient)" />
      </svg>
    </div>
  );
};

export default DefaultModalBackground;
